import { CategoryDto } from 'src/shared/services/categories/dtos/category-dto';

export interface CategoryCascaderOption extends CategoryDto {
  value: string;
  label: string;
  title: string;
  id: string;
  level: number;
  isLeaf: boolean;
  children: CategoryCascaderOption[];
}

const MAX_CATEGORY_LEVEL = 3;

export const convertToTreeCascader = (
  list: readonly CategoryDto[],
  level = 0,
  locale?: string,
): CategoryCascaderOption[] =>
  list.map((item) => {
    const localizedLabel = item.Locales?.find(
      (record) => record.LanguageId === locale,
    )?.LocaleValue;
    const label = localizedLabel ?? item.text;
    const sourceChildren = item.children ?? [];
    const children =
      level < MAX_CATEGORY_LEVEL
        ? convertToTreeCascader(sourceChildren, level + 1, locale)
        : [];

    return {
      ...item,
      value: item.key,
      label,
      title: label,
      id: item.key,
      level,
      isLeaf: children.length === 0,
      children,
    };
  });
